'use client';

import React__default, { useCallback } from 'react';
import { RadioWrapper, RadioContainer } from './Radio.css.js';

var SPACE_KEYCODE = 32;
function Radio(props) {
    var type = props.type, name = props.name, value = props.value, checked = props.checked, tabIndex = props.tabIndex, label = props.label, onChange = props.onChange;
    var typeClass;
    switch (type) {
        case 'info': {
            typeClass = 'abc-radio-info';
            break;
        }
        case 'success': {
            typeClass = 'abc-radio-success';
            break;
        }
        case 'danger': {
            typeClass = 'abc-radio-danger';
            break;
        }
        case 'warning': {
            typeClass = 'abc-radio-warning';
            break;
        }
        default: {
            typeClass = '';
        }
    }
    var uid = "".concat(name, "-").concat(value, "-radio");
    var handleOnKeyUp = useCallback(function (event) {
        if ((event === null || event === void 0 ? void 0 : event.keyCode) === SPACE_KEYCODE) {
            onChange && onChange(event);
        }
    }, [onChange]);
    return (React__default.createElement(RadioWrapper, null,
        React__default.createElement(RadioContainer, { type: type, className: "abc-radio radio ".concat(typeClass) },
            React__default.createElement("input", { onChange: onChange, type: 'radio', id: uid, name: name, value: value, checked: checked, tabIndex: -1 }),
            React__default.createElement("label", { htmlFor: uid, tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : -1, onKeyUp: handleOnKeyUp }, label))));
}

export { Radio as default };
//# sourceMappingURL=index.js.map
